import React from 'react';
import {useSelector} from "react-redux";

const SMSMainText = () => {

    const data = useSelector(s => s.smsSliceReducer);

    return (

        <div className="sms-box">
        <textarea className={"middle-tex"}
                  name="tex"
                  id="tex"
                  cols="30"
                  rows="10"
                  // onChange={(e) => dispatch(smsSliceActions.fillInput({mainText: e.target.value}))}
                  value={data?.mainText}/>
        </div>

    );
};

export default SMSMainText;
